import { render, staticRenderFns } from "./PrevArrow.vue?vue&type=template&id=034aa3e4&scoped=true&"
import script from "./PrevArrow.vue?vue&type=script&lang=js&"
export * from "./PrevArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034aa3e4",
  null
  
)

export default component.exports